import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-left-2",
  "use": "icon-left-2-usage",
  "viewBox": "0 0 208 50",
  "content": "<symbol viewBox=\"0 0 208 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-left-2\">\r\n<path d=\"M0 20C0 8.9543 8.95431 0 20 0H174.459C182.637 0 189.992 4.97902 193.029 12.5722L208 50H0V20Z\" fill=\"url(#icon-left-2_paint0_linear_72_35)\" />\r\n<defs>\r\n<linearGradient id=\"icon-left-2_paint0_linear_72_35\" x1=\"104\" y1=\"-10\" x2=\"104\" y2=\"50\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"#EFF8FF\" stop-opacity=\"0.5\" />\r\n<stop offset=\"1\" stop-color=\"#EFF8FF\" />\r\n</linearGradient>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol